import { Sidebar } from "..";
import "./dashboardwrapper.css";

const DashboardWrapper = ({children}) => {
    return <div className="dashboardwrapper">
        <Sidebar />
        <div className="content">   
            {children}
        </div>
    </div>
}

export default DashboardWrapper;